export default __webpack_public_path__ + "static/media/whitepaper.041c2a29.pdf";